import * as Schema from "effect/Schema";

import { TrimmedNonEmptyString } from "./baseSchemas.ts";

export const LocalHostSessionCredential = TrimmedNonEmptyString.pipe(
  Schema.brand("LocalHostSessionCredential"),
);
export type LocalHostSessionCredential = typeof LocalHostSessionCredential.Type;
